import { Icon } from "@material-ui/core"
import roff from './logos/roff.png'
                                       
export const Iconr1 = () => (
    <Icon>
        <img src={roff} />
    </Icon>
)